import * as React from 'react';
import classNames from 'classnames';
import {Icon} from '@iconify/react';

import './Menu.sass';


export function Menu(options: IMenuOption[]): React.ReactNode {
    return options.map((menuOptionProps, index) => <MenuButton key={index} {...menuOptionProps}/>);
}


export const MenuButton: React.FC<IMenuOption> = (props) => {

    function handleClick(e: any) {
        e.stopPropagation();
        if (props.callback) {
            props.callback();
        }
    }


    return (
        <div
            className={classNames('mvc-menu-option', {highlight: props.highlight})}
            key={props.text}
            onClick={handleClick}>
            <Icon icon={props.icon} height={12} style={{padding: 10, marginRight: 8}}/>
            {props.text}
        </div>
    );
};


export interface IMenuOption {
    text: string;
    icon: string;
    callback?: () => void;
    highlight: boolean;
}


// const userMenu: IMenuOptions[] = [
//   {
//     text: hasBlockedMe
//         ? "Messaging blocked"
//         : props.newMessages
//             ? props.newMessages + " new messages"
//             : "Message",
//     callback: console.log,
//     icon: "wpf:message",
//     highlight: !!props.newMessages,
//   },
//   {
//     text: "Profile",
//     callback: console.log,
//     icon: "fa-solid:user",
//     highlight: false,
//   },
//   {
//     text: props.isBuddy ? "Unbuddy" : "Buddy",
//     callback: console.log,
//     icon: "majesticons:users",
//     highlight: props.isBuddy,
//   },
//   {
//     text: props.isBlockedByMe ? "Unblock" : "Block",
//     callback: console.log,
//     icon: "fluent:block-24-filled",
//     highlight: !props.isBlockedByMe,
//   },
// ];
